import GenericDialog from "../../../components/dialog/generic-dialog.component";
import {translate} from "../../../translate/translate";
import * as React from "react";
import {PartNumber, Project} from "../../../models/basic/project";
import {ErrorMessage, Field, Form, Formik, FormikHelpers} from "formik";
import {
    Box,
    Checkbox,
    Chip,
    FormControl,
    Grid,
    InputAdornment,
    InputLabel, ListItemText,
    MenuItem,
    TextField,
    Typography
} from "@mui/material";
import Select from "@mui/material/Select";
import * as Yup from "yup";
import {toast} from "react-toastify";
import {ErrorComponent} from "../../../components/error/error.component";
import {sortListObj} from "../../../utils/list-utils";
import {useEffect} from "react";
import {FtBomService} from "../../../services/ft-bom-service";
import {SavePartNumber} from "../../../models/basic/ft-bom";

const AddPartNumberComponent = (props: any) => {
    const { openDialog, handleCloseDialog, row, isEdit } = props;

    const service = new FtBomService();

    const [object, setObject] = React.useState<SavePartNumber>(new SavePartNumber());
    const [invalidForm, setInvalidForm] = React.useState(true);

    const [dataSourceProject, setDataSourceProject] = React.useState<Project[]>([]);

    const [dataSourcePartNumbers, setDataSourcePartNumbers] = React.useState<PartNumber[]>([]);
    const [selectedPartNumbers, setSelectedPartNumbers] = React.useState<number[]>([]);

    useEffect(() => {
        if (row) {
            loadProjects();
            isEdit && initializeObject();
        }
    }, [row]);

    const initializeObject = () => {
        const filter = {
            client_id: row.client_id,
            ft_bom: row.ft_bom,
        }
        service.get_partnumbers_from_ftbom(filter).then(response => {
            handleObjChange(response.data);
            setSelectedPartNumbers(response.data.part_numbers.map((partNumber: PartNumber) => partNumber.id!));
            loadPartNumbers(response.data.project_id, filter.ft_bom);
        })
    }

    const checkForm = (row: SavePartNumber) => {
        setInvalidForm(!row.jiga || !row.rma || !row.project_id || !row.part_numbers.length);
    }

    const handleObjChange = (values: SavePartNumber) => {
        setObject(values);
        checkForm(values);
    }

    const loadProjects = () => {
        service.list_projects(row.client_id).then(response => {
            setDataSourceProject(sortListObj(response.data, "name"));
        }).catch((error: any) => {
            ErrorComponent(error);
        });
    }

    const loadPartNumbers = (project_id?: any, ft_bom?: any) => {
        const id = project_id || object.project_id;
        service.list_partnumbers(row.client_id, id, ft_bom).then(response => {
            setDataSourcePartNumbers(response.data);
        }).catch((error: any) => {
            ErrorComponent(error);
        });
    }

    const handleSubmit = () => {
        setTimeout(() => {
            const save = new SavePartNumber();
            save.part_numbers = getPartNumbers(selectedPartNumbers);
            save.client_id = row.client_id;
            save.project_id = object.project_id;
            save.ft_bom = row.ft_bom;
            save.jiga = Number(object.jiga);
            save.rma = Number(object.rma);

            service.save_part_numbers(save).then(() => {
                toast.success(translate.t("successfully_updated"));
                closeDialog();
            }).catch((error: any) => {
                ErrorComponent(error);
            });
        }, 500);
    }

    const getPartNumbers = (list: any[]) => {
        return dataSourcePartNumbers?.filter((partNumber: PartNumber) => list.includes(partNumber.id!));
    }

    const allPartNumbersSelected = () => {
        return selectedPartNumbers?.length === dataSourcePartNumbers?.length;
    }

    const renderPartNumbers = (selected: any[]) => {
        if (allPartNumbersSelected()) {
            return translate.t('all');
        }
        const partnumbers = dataSourcePartNumbers?.filter((partNumber: PartNumber) => selected.includes(partNumber.id!));
        const sorted = sortListObj(partnumbers, "part_number").map((partNumber: PartNumber) => partNumber.part_number);
        return sorted.join(", ");
    }

    const closeDialog = () => {
        handleCloseDialog();
        setObject(new SavePartNumber());
        setSelectedPartNumbers([]);
    }

    const resetPartNumbers = (obj: SavePartNumber) => {
        setSelectedPartNumbers([]);
        handleObjChange({
            ...obj,
            part_numbers: [],
        })
    }

    return (
        <GenericDialog
            open={openDialog}
            onClose={() => {
                closeDialog();
            }}
            title={"add_partnumber"}
            labelButton={translate.t("save")}
            disableConfirm={invalidForm}
            handleConfirm={() => {
                handleSubmit();
            }}
            colorButton={"primary"}>

            <Grid container spacing={2} direction={"column"}>
                <Grid size={4}>
                    <FormControl fullWidth>
                        <InputLabel
                            required={true}
                        >
                            {translate.t("project")}
                        </InputLabel>
                        <Select
                            name="project_id"
                            label={translate.t("project")}
                            variant={"outlined"}
                            fullWidth
                            value={object.project_id}
                            autoFocus={false}
                            aria-placeholder={translate.t("select_project")}
                            MenuProps={{
                                PaperProps: {
                                    style: {
                                        maxHeight: '400px',
                                    },
                                },
                            }}
                            onChange={(event: any) => {
                                const value = event.target.value;
                                const newObj = { ...object, project_id: value };
                                handleObjChange(newObj);
                                resetPartNumbers(newObj);
                                loadPartNumbers(value);
                            }}
                            required={true}>
                            {row && !row.client_id && (
                                <MenuItem value="" disabled>
                                    Selecione um cliente para a FTB
                                </MenuItem>
                            )}
                            {row && row.client_id && (!dataSourceProject || dataSourceProject.length == 0) && (
                                <MenuItem value="" disabled>
                                    Selecione um projeto
                                </MenuItem>
                            )}
                            {dataSourceProject?.map((project: Project) => (
                                <MenuItem key={project.id} value={project.id}>
                                    {project.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid>
                    <TextField
                        name="jiga"
                        label={translate.t("quantity_of_jiga")}
                        variant="outlined"
                        fullWidth
                        required
                        value={object.jiga}
                        type="number"
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            let value = event.target.value;
                            value = value.replace(/\D/g, "");

                            if (value.length > 255) {
                                return;
                            }

                            handleObjChange({
                                ...object,
                                jiga: Number(value),
                            });
                        }}
                        inputProps={{ maxLength: 54 }}
                    />
                </Grid>
                <Grid >
                    <TextField
                        name="rma"
                        label={translate.t("quantity_of_rma")}
                        variant="outlined"
                        fullWidth
                        required
                        value={object.rma}
                        type="number"
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            let value = event.target.value;
                            value = value.replace(/\D/g, "");

                            if (value.length > 255) {
                              return;
                            }

                            handleObjChange({
                                ...object,
                                rma: Number(value),
                            });
                        }}
                        inputProps={{ maxLength: 54 }}
                    />
                </Grid>
                <Grid size={4}>
                    <FormControl fullWidth>
                        <InputLabel required={true}>Part Numbers</InputLabel>
                        <Select
                            name="part_numbers"
                            label="Part Numbers"
                            variant={"outlined"}
                            fullWidth
                            autoFocus={false}
                            value={selectedPartNumbers}
                            disabled={!object.project_id}
                            onChange={(event: any) => {
                                if (event.target.value.includes(0)) {
                                    if (!allPartNumbersSelected()) {
                                        const partnumbers = dataSourcePartNumbers?.map((partnumber: PartNumber) => partnumber);
                                        setSelectedPartNumbers(partnumbers?.map(it => it.id!) || []);
                                        handleObjChange({
                                            ...object,
                                            part_numbers: partnumbers || [],
                                        })
                                        return;
                                    }
                                    setSelectedPartNumbers([]);
                                    handleObjChange({
                                        ...object,
                                        part_numbers: [],
                                    })
                                    return;
                                }
                                setSelectedPartNumbers(event.target.value);
                                handleObjChange({
                                    ...object,
                                    part_numbers: event.target.value,
                                })
                            }}
                            multiple
                            renderValue={(selected) => renderPartNumbers(selected)}
                            MenuProps={{
                                PaperProps: {
                                    style: {
                                        maxHeight: '400px',
                                    },
                                },
                                disableAutoFocusItem: true,
                            }}
                            inputProps={{
                                sx: {
                                    maxWidth: '480px !important',
                                    width: '480px !important',
                                }
                            }}
                        >
                            <MenuItem key={0} value={0}>
                                <Checkbox checked={allPartNumbersSelected()}/>
                                <ListItemText primary={
                                    <Box display="flex" alignItems="center" justifyContent="space-between">
                                        <Typography variant="body1">{translate.t('all')}</Typography>
                                        {allPartNumbersSelected() && <Typography variant="body2"
                                                                                 color="gray">{translate.t('clear')}</Typography>}
                                    </Box>
                                }/>
                            </MenuItem>
                            {dataSourcePartNumbers?.map((ftbom: any) => (
                                <MenuItem key={ftbom.id} value={ftbom.id}>
                                    <Checkbox checked={selectedPartNumbers.includes(ftbom.id)}/>
                                    <ListItemText primary={ftbom.part_number}/>
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>
        </GenericDialog>
    )
}

export default AddPartNumberComponent;
